import { CustomUser } from 'api';
import { ReducerAction, ReducerState } from 'common/types/reducers';

export const setUserInfo = (state: ReducerState, action: ReducerAction<{ user: CustomUser | null }>) => ({
  ...state,
  user: action.user,
});

export const setActivationEmail = (state: ReducerState, action: ReducerAction<{ activationEmail: string }>) => ({
  ...state,
  ...action,
});

export const setIsRestrictedUser = (
  state: ReducerState,
  action: ReducerAction<{ isRestrictedUser: boolean | null }>
) => ({
  ...state,
  ...action,
});

export default setUserInfo;
